<template>
  <div>
    <UserMyPage></UserMyPage>
  </div>
</template>

<script>
import UserMyPage from "@/components/user/UserMypage.vue";

export default {
  name: "UserMyPageView",
  components: {
    UserMyPage
  }
};
</script>

<style></style>
